import { gql } from '@nobia/zeus-components/lib/apollo'

import { AppointmentFragment } from '../../graphql/AppointmentFragment'
import { CustomerProjectStateFragment } from '../../graphql/CustomerFragments'
import { MarbodalQuoteFragment } from '../../graphql/DesignQuoteFragment'
import {
  MarbodalOrderFragment,
  SimpleOrderFragment,
} from '../../graphql/OrderFragments'

export const HomePageQuery = gql`
  ${CustomerProjectStateFragment}
  ${SimpleOrderFragment}
  ${AppointmentFragment}
  ${MarbodalQuoteFragment}
  ${MarbodalOrderFragment}
  query ProjectStateQuery($storeId: Int, $multiStore: Boolean!) {
    me {
      id
      customer {
        id
        projectState @skip(if: $multiStore) {
          ...CustomerProjectState
          order {
            ...SimpleOrder
          }
          appointment {
            ...Appointment
          }
        }
        journey(storeId: $storeId) @include(if: $multiStore) {
          storeId
          status
          statusString
          statusReferenceId
          created
          referenceObject {
            ... on Appointment {
              ...Appointment
            }
            ... on MarbodalQuote {
              ...MarbodalQuote
            }
            ... on MarbodalOrder {
              ...MarbodalOrder
            }
          }
        }
      }
    }
  }
`
